import { render, staticRenderFns } from "./BlockButtons.vue?vue&type=template&id=02c52d88&"
import script from "./BlockButtons.vue?vue&type=script&lang=js&"
export * from "./BlockButtons.vue?vue&type=script&lang=js&"
import style0 from "./BlockButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports